import { ElementRef, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationResult } from '../../../core/validators';
var FormValidationComponent = /** @class */ (function () {
    function FormValidationComponent(element, translate) {
        this.element = element;
        this.translate = translate;
    }
    FormValidationComponent.prototype.ngOnChanges = function () {
        if (this.hasErrors)
            this.scrollToMe();
    };
    Object.defineProperty(FormValidationComponent.prototype, "hasErrors", {
        get: function () {
            return this.result && this.result.hasErrors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormValidationComponent.prototype, "errorMessages", {
        get: function () {
            var _this = this;
            return Object.keys(this.result.errors).reduce(function (msgs, key) { return msgs.concat(_this.result.errors[key]); }, []);
        },
        enumerable: true,
        configurable: true
    });
    FormValidationComponent.prototype.scrollToMe = function () {
        var top = this.element.nativeElement.scrollTop;
        if (window)
            window.scrollTo(0, top);
    };
    return FormValidationComponent;
}());
export { FormValidationComponent };
